module.exports = __webpack_public_path__ + "img/tisco.79e3a22b.svg";